//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import ApiUrls from '@/constants/ApiUrls';

export default (api) => {
    return {
        fetch:   () => {
            return api.get(ApiUrls.API_CHECK_IN_URL);
        },
        checkIn: (userId, boulderingHallId) => {
            return api.post(
                ApiUrls.API_CHECK_IN_URL,
                {
                    user:           userId,
                    boulderingHall: boulderingHallId,
                },
            );
        },
    };
};
